import styled from "styled-components";

export const TitleWrapper = styled.div`
  padding: 10px 0px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.textColor};
  margin-bottom: 40px;
  box-shadow: ${({ theme }) => theme.colors.boxShadowBottomOnly};
`;
